import { render, staticRenderFns } from "./FooterContainerArea.vue?vue&type=template&id=0d0230e1&"
import script from "./FooterContainerArea.vue?vue&type=script&lang=js&"
export * from "./FooterContainerArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports